import React from "react";

import { configGame } from "../../../data/config"


interface IframeworkReels {
    data: {
        "GRID_COLUMN": number,
        "GRID_WIDTH": number,
        "GRID_ROWS": number,
        "SPIN_TYPE": number,
        "GRID_GAP": number,
        "SYMBOL_WIDTH": number,
        "SYMBOL_HEIGHT": number,
        "staggerDropDelayReelStart": number,

        "createPosition": {
            "x": number,
            "y": number
        },
        "endPosition": {
            "x": number,
            "y": number
        },
        "tiltAngle": number,
        "tiltAngleAfterBlast": number,
        "tiltDuration": number,
        "reversetiltDuration": number,

        "blastDuration": number,
        "delayInSymbolAnimationPlay": number,
        "singlePositionDropDuration": number,
        "singlePositionDropDurationFromTop": number,
        "delayDropDuration": number,
        "dropAfterBlastDuration": number,
        "delayDropDurationAfterBlast": number,
        "staggerColumnDelay": number,
        "staggerDropDelay": number,
        "gridPositionIds": any,
        "gridPositions": any,
    }

}

export const frameworkGrids: IframeworkReels = {
    data: {
        "GRID_COLUMN": configGame.REEL_COLUMN,
        "SPIN_TYPE": configGame.SPIN_TYPE,
        "GRID_WIDTH": configGame.REEL_WIDTH,
        "GRID_ROWS": configGame.REEL_ROWS,
        "GRID_GAP": configGame.REEL_GAP,
        "SYMBOL_WIDTH": configGame.SYMBOL_WIDTH,
        "SYMBOL_HEIGHT": configGame.SYMBOL_HEIGHT,

        "staggerDropDelayReelStart": 1,
        "staggerDropDelay": 50,
        "staggerColumnDelay": 50,
        "blastDuration": 1500,
        "delayInSymbolAnimationPlay": 1,
        "singlePositionDropDuration": 60,//60 means 1 sec
        "singlePositionDropDurationFromTop": -1,
        "dropAfterBlastDuration": 30,
        "tiltAngle": 0.05,
        "tiltAngleAfterBlast": 0.05,
        "tiltDuration": 80,
        "reversetiltDuration": 50,
        "delayDropDurationAfterBlast": 700,
        "delayDropDuration": 50,
        "createPosition": {
            "x": 64,
            "y": -138
        },
        "endPosition": {
            "x": 0,
            "y": configGame.SYMBOL_HEIGHT * 7
        },
        "gridPositionIds": [5, 4, 3, 2, 1, 0],
        "gridPositions": [
            {
                "x": 0,
                "y": configGame.SYMBOL_HEIGHT * 5
            },
            {
                "x": 0,
                "y": configGame.SYMBOL_HEIGHT * 4
            },
            {
                "x": 0,
                "y": configGame.SYMBOL_HEIGHT * 3
            },
            {
                "x": 0,
                "y": configGame.SYMBOL_HEIGHT * 2
            },
            {
                "x": 0,
                "y": configGame.SYMBOL_HEIGHT
            },
            {
                "x": 0,
                "y": 0
            }
        ]


    }


};

export const GameGridConfigurationContext = React.createContext(
    {}
);